export default {
    product:{
        name:'Personalize-vue',
        version: import.meta.env.VITE_BUILD_VERSION
    }
}